module.exports = __webpack_public_path__ + "img/service_qr.93619572.jpg";